<template>
    <div class="w-full lotto-results-grid--terminal">
        <div class="lotto-results__header--terminal">
            <div class="lotto-results__header--date--terminal">
                {{ $t('date') | upperCase }}
            </div>
            <div class="lotto-results__header--lottery-name--terminal">
                {{ $t('lottery') | upperCase }}
            </div>
            <div class="lotto-results__header--winning-numbers--terminal">
                {{ $t('winning numbers') | upperCase  }}
            </div>
        </div>
        <VirtualScroller
            :items="items"
            :pageMode="false"
            style="height: 88.5vh;"
        >
            <template slot-scope="props">
                <LottoGridRow
                    v-for="event in props.item.events"
                    :key="event.id"
                    v-bind="event"
                />
            </template>
        </virtualscroller>
    </div>
</template>

<script>
    import { VirtualScroller } from 'vue-virtual-scroller';
    import LottoGridRow from './LottoGridRow.vue';

    const lottoRowHeight = 56;
    const rowGroupSize = 10;

    export default {
        name: 'LottoGrid',
        props: {
            events: {
                type: Array,
                required: true
            }
        },
        computed: {
            // grouping elements into chunks of 10 beacuse virtual scroller has a limit of 1000 elements
            items() {
                if (this.events.length === 0) {
                    return [];
                }

                const fullGroupHeight = lottoRowHeight * rowGroupSize;
                const groups = [];
                let currentGroup = {
                    events: [],
                    height: fullGroupHeight,
                    index: 0,
                };
                for (let i = 0; i < this.events.length; i += 1) {
                    currentGroup.events.push(this.events[i]);
                    if ((i + 1) % rowGroupSize === 0) {
                        groups.push(currentGroup);
                        currentGroup = {
                            events: [],
                            height: fullGroupHeight,
                            index: Math.ceil(i / rowGroupSize),
                        };
                    }
                }
                let lastGroup = groups[groups.length - 1];
                if (!lastGroup || lastGroup.index !== currentGroup.index) {
                    groups.push(currentGroup);
                    lastGroup = currentGroup;
                    lastGroup.height = lastGroup.events.length * lottoRowHeight;
                }
                return groups;
            }
        },
        components: {
            LottoGridRow,
            VirtualScroller,
        },
    };
</script>



// WEBPACK FOOTER //
// src/terminal/app/modules/results/lottoOffer/content/LottoGrid.vue